import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'

import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { FloFilmsComponent } from './films.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: FloFilmsComponent,
        canActivate: [MetaGuard],
        data: {
          segment: SegmentTagMap.FLOFILMS,
          noTopScroll: false,
          shouldShowEventTicker: true,
          meta: {
            title: 'meta_films_page_title',
            description: 'meta_films_page_description',
            'og:type': 'meta_default_type'
          }
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class FloFilmsRoutingModule {}
